import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Banner(props) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Chatbot">
                <h1>API Integration Services</h1>
              </div>
              <p className="main_para">
                With custom API development and integration for your platform or
                app, you can streamline your business and connect your services
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banner_content_txt">
              <p>
                {" "}
                Scale the capabilities of your business solutions through custom
                API development and integration services for high-end features.
              </p>
              <ul>
                <li>Better Solution Functionality and Capacity </li>
                <li>Improved Business Process and Analytics </li>
                <li>Accelerated Delivery of Business Value </li>
                <li>Comprehensive Architecture </li>
              </ul>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
